export default "__VITE_ASSET__DmE9czYj__"